import type {BioIconProps} from '../common-types'

export function FeedbackStar({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M9.96808 1.57914C10.2875 0.702205 11.5278 0.702205 11.8473 1.57914L13.6888 6.63409C13.8327 7.02899 14.2081 7.2918 14.6284 7.2918H20.3216C21.3178 7.2918 21.7014 8.58929 20.8654 9.13101L16.4637 11.9833C16.0726 12.2367 15.9084 12.7268 16.068 13.1648L17.7942 17.9033C18.1227 18.8049 17.1161 19.6066 16.3108 19.0848L11.4515 15.936C11.1206 15.7216 10.6947 15.7216 10.3639 15.936L5.50452 19.0848C4.69929 19.6066 3.69268 18.8049 4.02112 17.9033L5.74739 13.1648C5.90693 12.7268 5.74276 12.2367 5.3516 11.9833L0.949938 9.13101C0.113947 8.58929 0.49758 7.2918 1.49374 7.2918H7.18695C7.60724 7.2918 7.98268 7.02899 8.12654 6.63409L9.96808 1.57914Z"
        fill={fill}
      />
    </svg>
  )
}
